/* tslint:disable:max-line-length */
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('License');

export const addMedium = actionCreator<ILicenseAddMediumActionPayload>('ADD_USAGE_FOR_MEDIUM');
export const removeMedium = actionCreator<ILicenseRemoveUsageActionPayload>('REMOVE_USAGE_FOR_MEDIUM');
export const setEditingUsageIndex = actionCreator<ILicenseEditUsageActionPayload>('SET_EDITING_USAGE_INDEX');
export const setComponentForUsage = actionCreator<ISetComponentForUsageActionPayload>('ADD_COMPONENT_TO_USAGE');
export const clearLicense = actionCreator('CLEAR_ALL');
export const setUsages = actionCreator<ILicenseSetUsagesActionPayload>('SET_USAGES');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/license.ts